/* eslint-disable @typescript-eslint/naming-convention */
'use server';

import { Locale } from '../../Entities/Locale/Locale.entity';

export const isUuid = (str?: string | null) => {
  if (!str) return false;

  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  return uuidRegex.test(str);
};

export async function nativeSaveSearchAction(
  deviceId: string | undefined | null,
  deviceToken: string,
  searchQuery: string,
  plpUrl: string,
  locale: Locale,
) {
  const validDeviceId = isUuid(deviceId) ? deviceId : undefined;

  try {
    const response = await fetch(`${process.env.COMMON_API_URL}/i15/saved-searches`, {
      method: 'POST',
      body: JSON.stringify({ deviceId: validDeviceId, deviceToken, searchQuery, plpUrl }),
      headers: {
        Accept: 'application/json',
        'content-type': 'application/json',
        'x-heycar-tenant': locale,
      },
    });

    return {
      text: response.statusText,
      error: response.status !== 201,
    };
  } catch (error: any) {
    console.error(error);
    return {
      text: error,
      error: true,
    };
  }
}

export async function nativeDeleteSaveSearch(
  savedSearchId: string,
  encryptedEmail: string,
  locale: Locale,
) {
  try {
    const response = await fetch(
      `${process.env.COMMON_API_URL}/i15/saved-searches/${savedSearchId}`,
      {
        method: 'DELETE',
        body: JSON.stringify({ encryptedEmail }),
        headers: {
          Accept: 'application/json',
          'content-type': 'application/json',
          'x-heycar-tenant': locale,
        },
      },
    );

    return {
      text: response.statusText,
      error: response.status !== 204,
    };
  } catch (error: any) {
    console.error(error);
    return {
      text: error,
      error: true,
    };
  }
}
